import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";
import logger from "../utils/logger";

const API_ENDPOINT = API_URL + "api/v1";

export interface DigitalCardPayload {
  name: string;
  email: string;
  phone: string;
  whatsapp?: string;
  designation?: string;
  companyName?: string;
  companyAddress?: string;
  briefDescription?: string;
  website?: string;
  facebook?: string;
  instagram?: string;
  linkedIn?: string;
  googleCalendar?: string;
}

export interface DigitalCardResponse {
  _id: string;
  digitalCardId?: string;
  name: string;
  email: string;
  phone: string;
  whatsapp?: string;
  designation?: string;
  companyName?: string;
  companyAddress?: string;
  briefDescription?: string;
  website?: string;
  facebook?: string;
  instagram?: string;
  linkedIn?: string;
  googleCalendar?: string;
  profilePicture?: string;
  cardUrl?: string;
  vcfUrl?: string | null;
  uniqueLinkId?: string;
  organization?: string;
  createdBy?: string;
  updatedBy?: string;
  isDeleted?: boolean;
  deletedAt?: string | null;
  deletedBy?: string | null;
  isToRender?: boolean;
  extraDetails?: Record<string, any>;
  customFields?: Record<string, any>;
  viewedCount?: number;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

/**
 * Get the user's digital card
 */
export const getDigitalCard = () => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get<{ data: DigitalCardResponse; status: boolean; message: string }>(
    `${API_ENDPOINT}/digital-card`,
    { headers: obj }
  );
};

/**
 * Create a new digital card
 */
export const createDigitalCard = (data: DigitalCardPayload) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.post<{ data: DigitalCardResponse; status: boolean; message: string }>(
    `${API_ENDPOINT}/digital-card`,
    data,
    { headers: obj }
  );
};

/**
 * Update the user's digital card
 */
export const updateDigitalCard = (data: DigitalCardPayload) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.put<{ data: DigitalCardResponse; status: boolean; message: string }>(
    `${API_ENDPOINT}/digital-card`,
    data,
    { headers: obj }
  );
};

/**
 * Delete the user's digital card
 */
export const deleteDigitalCard = () => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.delete<{ status: boolean; message: string }>(
    `${API_ENDPOINT}/digital-card`,
    { headers: obj }
  );
};
